export enum ProductUnitType {
  AREA = 'area',
  PIECE = 'piece'
}
